/* ============================================================
   senchado-box-preselect.js — Huckleberry BOXページ引き継ぎ受信側
   仕様: docs/spec-box-slot-ui.md（Sprint 2 機能6 / エッジケース1・8 / 決裁2）

   ファネルLP から `?preselect=<product_id>,<product_id>,...` 付きで
   BOX親商品ページ（Huckleberry App Block が描画）へ遷移した時に、
   該当する子商品のチェックボックスを自動選択する。

   - XSSガード: SenchadoBoxState.parsePreselect が数値のみ許可
   - DOMガード: Huckleberry の DOM 構造が変わって要素が見つからない場合は
     フォールバック通知を表示し、window.SENCHADO_BOX_GUARD_REPORT（Sentry等の
     連携フック）があれば呼び出す
   - Huckleberry は非同期描画のため MutationObserver + タイムアウトで待つ

   注意: Huckleberry 側 DOM は STANDARD プランでは変更不可（CSSのみ）。
   実セレクタは BOX 開設後に SELECTOR_CANDIDATES を実DOMに合わせて更新し、
   Playwright 週次 cron（release-checklist 参照）で存続を監視する。
   ============================================================ */
(function () {
  'use strict';

  var S = window.SenchadoBoxState;
  if (!S) return;

  var ids = S.parsePreselect(window.location.search);
  if (ids.length === 0) return;

  var TIMEOUT_MS = 10000;
  var POLL_MS = 250;

  /* Huckleberry 子商品チェックボックスの候補セレクタ（{id} を商品IDに置換）。
     window.SENCHADO_BOX_PRESELECT_SELECTORS で上書き可能（テーマ設定を変えずに
     カスタマイズできる緊急ハッチ）。 */
  var SELECTOR_CANDIDATES = window.SENCHADO_BOX_PRESELECT_SELECTORS || [
    'input[type="checkbox"][data-product-id="{id}"]',
    'input[type="checkbox"][data-productid="{id}"]',
    '[data-product-id="{id}"] input[type="checkbox"]',
    'input[type="checkbox"][value="{id}"]'
  ];

  function findCheckbox(id) {
    for (var i = 0; i < SELECTOR_CANDIDATES.length; i++) {
      var sel = SELECTOR_CANDIDATES[i].split('{id}').join(String(id));
      var el = null;
      try { el = document.querySelector(sel); } catch (e) { el = null; }
      if (el) return el;
    }
    return null;
  }

  function check(el) {
    if (el.checked) return true;
    try {
      el.click(); // Huckleberry 側のリスナー（金額再計算等）を発火させるため click を使う
      if (!el.checked) {
        el.checked = true;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return el.checked;
    } catch (e) {
      return false;
    }
  }

  function report(payload) {
    if (typeof window.SENCHADO_BOX_GUARD_REPORT === 'function') {
      try { window.SENCHADO_BOX_GUARD_REPORT(payload); } catch (e) { /* noop */ }
    } else if (window.console && console.warn) {
      console.warn('[senchado-box-preselect]', payload);
    }
  }

  function showFallbackNotice() {
    if (document.querySelector('[data-box-preselect-notice]')) return;
    var el = document.createElement('div');
    el.setAttribute('data-box-preselect-notice', '');
    el.setAttribute('role', 'status');
    el.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'z-index:200', 'max-width:calc(100vw - 40px)', 'background:#1A1A1A', 'color:#FFFFFF',
      'font-size:13px', 'line-height:1.65', 'padding:12px 20px',
      'font-family:"Noto Sans JP",sans-serif'
    ].join(';');
    el.textContent = '選んだ茶葉を自動で反映できませんでした。お手数ですが、ボックスの内容を手動でお選びください。';
    document.body.appendChild(el);
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 8000);
  }

  function attempt() {
    var missing = [];
    var checked = [];
    ids.forEach(function (id) {
      var el = findCheckbox(id);
      if (el && check(el)) checked.push(id);
      else missing.push(id);
    });
    return { checked: checked, missing: missing };
  }

  function run() {
    var started = Date.now();
    var timer = null;
    var observer = null;

    function finish(result) {
      if (timer) clearInterval(timer);
      if (observer) observer.disconnect();
      if (result.missing.length > 0) {
        showFallbackNotice();
        report({
          type: 'preselect_failed',
          requested: ids,
          checked: result.checked,
          missing: result.missing,
          url: window.location.pathname
        });
      }
    }

    var first = attempt();
    if (first.missing.length === 0) { finish(first); return; }

    timer = setInterval(function () {
      var result = attempt();
      if (result.missing.length === 0 || Date.now() - started > TIMEOUT_MS) {
        finish(result);
      }
    }, POLL_MS);

    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () {
        var result = attempt();
        if (result.missing.length === 0) finish(result);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
